// Translation keys for validation messages
export const REQUIRED_FIELD_MESSAGE = 'validation.required';
export const MIN_LENGTH_MESSAGE = 'validation.minLength';
export const MAX_LENGTH_MESSAGE = 'validation.maxLength';
export const EMAIL_NOT_VALID_MESSAGE = 'validation.emailInvalid';